<template>
  <div class="component-model">
    <template v-if="!disabled">
      <a-upload
        :multiple="multipleSelected"
        :accept="uploadAccept"
        :action="uploadFileUrl"
        :file-list="fileList"
        :beforeUpload="beforeUpload"
        :show-upload-list="false"
        @change="handleChange"
      >
        <a-button :disabled="dataList.length > maxCount-1 || uploading">
          <a-icon type="upload"/>
          {{ uploading ? '上传中...' : '上传' }}
        </a-button>
      </a-upload>
      <span class="pl10">{{ tips }}</span>
    </template>
    <draggable
      class="syllable_ul"
      element="ul"
      :list="dataList"
      :options="{group:'title', animation:150}"
      :no-transition-on-drag="true"
      @change="onChange"
    >
      <transition-group type="transition" :name="!drag? 'syll_li' : null" :css="true">
        <div class="image-list" v-for="(url, index) in dataList" :key="url" :style="imageStyle">
          <video v-if="isVideoUrl(url)" class="image" :src="url" muted></video>
          <img v-else class="image" :src="url" alt="">
          <div v-if="index==0 && showFlag && !isTransition" class="master-image">封面主图</div>
          <div class="icon-delete" v-if="(proId && index!==0)||showDelete || isTransition">
            <a-icon @click="handleDelete(url)" type="delete"/>
          </div>
        </div>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import ossUploadMixins from '@/utils/mixins/ossUploadMixins'

export default {
  name: 'CustomUploadProImages',
  components: { draggable },
  mixins: [ossUploadMixins],
  props: {
    multipleSelected: {//多选状态
      type: Boolean,
      default: false
    },
    isProduct: {
      type: Boolean,
      default: true
    },
    tips: {
      type: String,
      default: '建议图片长宽比为1:1，图片大小在800px*800px以上'
    },
    maxCount: {
      type: Number,
      default: 5
    },
    draggableUpdate: {//拖拽更新状态
      type: Boolean,
      default: false
    },
    showFlag: {//拖拽更新状态
      type: Boolean,
      default: true
    },
    imageStyle: {
      type: Object,
      default: () => {
      }
    },
    disabled: {//禁用状态
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: function() {
        return []
      }
    },
    proId: [String, Number],
    showDelete: {
      type: Boolean,
      default: false
    },
    isTransition: { //是否展示封面主图
      type: Boolean,
      default: false
    },
    // 是否兼容视频上传（同一按钮：图片走旧接口，视频走 OSS 直传）
    enableVideo: {
      type: Boolean,
      default: false
    },
    maxVideoSize: {
      // 视频最大体积，单位 MB
      type: Number,
      default: 200
    }
  },
  data() {
    return {
      drag: false,
      dialogVisible: false,
      uploading: false,
      uploadFileUrl: this.getUploadFileUrl(),
      dataList: [],//显示的图片
      fileList: []//选中的文件
    }
  },
  computed: {
    uploadAccept() {
      return this.enableVideo ? 'image/jpeg,image/png,video/*' : 'image/jpeg,image/png'
    }
  },
  watch: {
    'value': function(newVal, oldVal) {
      this.dataList = newVal ? newVal : []
    },
    'fileList': function(newVal, oldVal) {
      if (this.dataList.length < this.maxCount) {//小于最大值
        const urlList = newVal.map(file => {
          if (file && file.response && file.response.data) {
            return file.response.data
          }
          return ''
        })
        let addUrls = urlList.filter(src => src && !this.dataList.includes(src))
        if (addUrls && addUrls.length > 0) {
          const count = this.maxCount - this.dataList.length
          addUrls = addUrls.slice(0, count)
          this.dataList = [...this.dataList, ...addUrls]
          this.postResult()
        }
      } else {
        if (this.maxCount > 1) {
          this.$message.warn('最多只能选择' + this.maxCount + '张图片')
        } else {
          if (newVal.length === 1 && newVal[0].response) {
            const newUrl = newVal[0].response.data
            this.dataList = [newUrl]
            this.postResult()
          }
        }
      }
    }
  },
  mounted() {
    this.dataList = this.value ? this.value : []
  },
  methods: {
    //发送结果
    postResult() {
      this.$emit('input', this.dataList)
      this.$emit('change', this.dataList)
    },
    onChange(evt) {
      this.$emit('draggable', this.dataList)
      this.postResult()
      if (this.isProduct) {
        this.updateProImages(this.dataList)
      }
    },
    //获取图片上传地址
    getUploadFileUrl() {
      let appConfig = this.getAppConfig()
      return appConfig.baseUrl + (appConfig.isDev ? '/' : '') + 'base/upload'
    },
    appendUploadResult(url) {
      if (!url) return
      if (this.dataList.length < this.maxCount) {
        if (!this.dataList.includes(url)) {
          this.dataList = [...this.dataList, url]
          this.postResult()
        }
        return
      }
      if (this.maxCount > 1) {
        this.$message.warn('最多只能选择' + this.maxCount + '张图片')
        return
      }
      this.dataList = [url]
      this.postResult()
    },
    handleChange({ fileList }) {
      this.getLogUtils().logWithTag('handleChange', fileList)
      let tempList = [...fileList]
      const size = fileList.length
      if (this.maxCount === 1 && size > 1) {
        tempList = [fileList[size - 1]]
      }
      this.fileList = tempList.map(file => {
        if (file.response) {
          file.url = file.response.data
        }
        return file
      })
      this.getLogUtils().logWithTag('操作handleChange', this.fileList)
    },
    handleDelete(url) {
      if (this.isProduct) {
        this.deleteRequest(url).then(res => {
          this.deleteImage(url)
          this.getLogUtils().logWithTag('getGoodsType', res)
          this.$message.success('商品轮播图删除成功')
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      } else {
        this.deleteImage(url)
        this.$message.success('图片删除成功')
      }
    },
    deleteImage(url) {
      this.fileList = this.fileList.filter(file => file && file.response && file.response.data && file.response.data !== url)
      this.dataList = this.dataList.filter(item => item !== url)
      this.postResult()
    },
    // 删除图片请求
    deleteRequest(imgUrl) {
      const params = {
        imgUrl: imgUrl,
        proId: this.proId
      }
      return this.getHttpServices().getProService().post('public/delImg', params)
    },
    beforeUpload(file) {
      this.getLogUtils().logWithTag('beforeUpload', file)
      // 开启视频兼容时：视频走 OSS 直传，拦截默认上传
      if (this.enableVideo && this.isVideoFile(file)) {
        if (!this.validateVideoSize(file, this.maxVideoSize)) {
          return false
        }
        this.handleOssVideoUpload(file, (fileUrl) => this.appendUploadResult(fileUrl), 'uploading')
        return false
      }
      // 图片继续走旧接口 base/upload
      const isJPG = file.type === 'image/jpeg'
      const isJPEG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      if (!(isJPG || isJPEG || isPNG)) {
        this.$message.error(this.enableVideo
          ? '上传文件格式不正确，仅支持 JPG、JPEG、PNG 或视频'
          : '上传图片的格式不正确，不是JPG、JPEG、PNG')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 3
      if (!isLt2M) {
        this.$message.error('上传的文件不能大于3M!')
        return false
      }
      return true
    },
    // 更新图片排序
    updateProImages(imageList) {
      if (this.proId && this.draggableUpdate) {
        let params = {
          imgUrl: imageList && imageList.length > 0 ? imageList : [],
          proId: this.proId
        }
        this.getHttpServices().getProService().post('public/orderByProImg', params).then(res => {
          this.getLogUtils().logWithTag('sortProImage', res)
          this.$message.success('商品轮播图片排序成功')
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      }
    }
  }
}
</script>
<style scoped lang="less">
ul {
  padding: 0;
}

.image-list {
  float: left;
  width: 110px;
  height: 110px;
  margin: 0 8px 8px 0;
  padding: 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  position: relative;

  .image {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    width: 110px;
    height: 110px;
  }

  .master-image {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 20px;
    line-height: 20px;
    text-align: center;
    font-size: 14px;
    color: #fff;
    background: rgba(0, 0, 0, 0.4);
    z-index: 200;
  }

  .icon-delete {
    width: 14px;
    height: 14px;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 300;
    cursor: pointer;
    line-height: 14px;
  }
}

.pl10 {
  padding-left: 10px;
}
</style>
